// extracted by mini-css-extract-plugin
var _1 = "NRd4Rh8d5anUUKmD_zwk";
var _2 = "O9wwTAmCxBfb0Ta6kxav";
var _3 = "NRd4Rh8d5anUUKmD_zwk";
var _4 = "O9wwTAmCxBfb0Ta6kxav";
export { _1 as "failure-face", _2 as "failure-message", _3 as "failureFace", _4 as "failureMessage" }
